import React, { type CSSProperties, type PropsWithChildren } from 'react'
import classNames from 'classnames'
import { type CallHistory } from 'entities/CallHistory/model/CallHistory'
import { CellContact } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/CellContact/CellContact'
import { CellOutcome } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/CellOutcome/CellOutcome'
import { CellDuration } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/CellDuration/CellDuration'
import styles from './styles.module.scss'

type IListItemProps = {
  item: CallHistory
  setHoverId: (id: number | null) => void
  hoverId: number | null
}

const CellWrapper = ({
  children,
  minWidth,
}: PropsWithChildren<{ minWidth?: CSSProperties['minWidth'] }>) => (
  <td className={classNames(styles.cell)} style={{ minWidth }}>
    {children}
  </td>
)

export const ListItem = ({ item, setHoverId, hoverId }: IListItemProps) => {
  return (
    <tr
      className={styles.row}
      onMouseEnter={() => setHoverId(item.id)}
      onMouseLeave={() => setHoverId(null)}
    >
      <CellWrapper>
        <CellContact info={item} withPhoneContent showActions={hoverId === item.id} />
      </CellWrapper>
      <CellWrapper>
        <CellOutcome
          type={item.callType}
          isForwarded={item.isForwarded}
          isConferenceCall={!!item.call_conference?.participants?.length}
          isOutboundCall={item.isOutboundCall}
          isInboundCall={item.isInboundCall}
          label={item.outcomeType}
        />
      </CellWrapper>
      <CellWrapper minWidth={60}>
        <CellDuration duration={item.callDuration} />
      </CellWrapper>
    </tr>
  )
}
